// extracted by mini-css-extract-plugin
export default {"notFound":"NotFound_notFound__X0GNY","notFound__img":"NotFound_notFound__img__8XU54","notFound__title":"NotFound_notFound__title__TC1pb"};